<template>
  <div class="container-fluid mt-5">
    <vs-breadcrumb :items="[
          { title: 'Seguridad', url: '/security' },
          { title: 'Accesos temporales', active: true },
      ]"></vs-breadcrumb>

      <div class="row">
        <div class="col-md-7">
          <vx-card title="Solicitudes pendientes">
            <vs-table
                pagination
                :data="pendingRequests"
                no-data-text="No ha solicitudes pendientes por aprobar">
              <template slot="header">
                <vs-button
                  class="mb-2"
                  icon="add" @click="createRequestAccessHandler(null)">
                  Nueva solicitud
                </vs-button>
              </template>
              <template slot="thead">
                <vs-th>Modúlo</vs-th>
                <vs-th>Motivo</vs-th>
                <vs-th>F. Solicitud</vs-th>
                <vs-th>F. Expiración</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr v-for="requestPending in data">
                  <vs-td>{{requestPending.backoffice_menu_item.text}}</vs-td>
                  <vs-td>{{requestPending.request_purpose}}</vs-td>
                  <vs-td>{{requestPending.created_at|humanizeDate}}</vs-td>
                  <vs-td>{{requestPending.validity_date}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
        <div class="col-md-5">
          <vx-card title="Solicitudes recientes">
            <vs-table pagination :max-items="5" :data="lastRequests" no-data-text="No tiene historial de solicitudes.">
              <template slot="thead">
                <vs-th>Modúlo</vs-th>
                <vs-th>F. Expiración</vs-th>
                <vs-th>Opciones</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr v-for="request in data">
                  <vs-td>{{request.backoffice_menu_item.text}}</vs-td>
                  <vs-td>{{request.validity_date}}</vs-td>
                  <vs-td>
                    <vs-button type="border" size="small" @click="createRequestAccessHandler(request)">
                      Solicitar de nuevo
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>

      <vs-popup :active.sync="showCreateRequestAccess" title="Solicitud de acceso temporal">
        <div>
          <label>Menú</label>
          <v-select
            :danger="true"
            @input="parentMenuHandler"
            v-model="parentMenu"
            v-validate="'required'"
            label="text"
            name="parentMenu"
            :reduce="menu => menu.id"
            :options="menus"></v-select>
          <v-error v-if="errors.has('parentMenu')" :error="errors.first('parentMenu')"></v-error>
        </div>
        <div class="mt-2" v-if="parentMenu !== null">
          <label>Submenú</label>
          <v-select
            v-validate="'required'"
            label="text"
            :reduce="subNav => subNav.id"
            :options="subMenus"
            name="menu"
            v-model="createRequestAccessForm.menuItemId"></v-select>

          <v-error v-if="errors.has('menu')" :error="errors.first('menu')"></v-error>
        </div>

        <vs-textarea
          :danger="errors.has('requestPurpose')"
          style="margin-bottom: 0px;"
          v-validate="'required'"
          name="requestPurpose"
          v-model="createRequestAccessForm.requestPurpose"
          class="mt-4"
          label="Motivo de la solicitud"></vs-textarea>
        <v-error
          v-if="errors.has('requestPurpose')"
          :error="errors.first('requestPurpose')"></v-error>

        <vs-input
          class="mt-2 w-full"
          :danger="errors.has('days')"
          :danger-text="errors.first('days')"
          name="days"
          v-model="createRequestAccessForm.days"
          v-validate="'required|max_value:90'"
          label="¿Por cuantos días ocupas el acceso?"></vs-input>

        <vs-button
            @click="saveRequestAccessHandler"
            class="mt-5 float-right"
            :disabled="errors.count() > 0">
          Solicitar acceso
        </vs-button>
      </vs-popup>
  </div>
</template>

<script>
import {_humanizeDate} from "@/filters/momentTzConvert";
export default {
  name: "TemporaryPermissions",
  data: () => ({
    showCreateRequestAccess: false,
    createRequestAccessForm: {},
    menus: [],
    subMenus: [],
    parentMenu: null,
    pendingRequests: [],
    lastRequests: []
  }),
  filters: {
    humanizeDate: _humanizeDate
  },
  async mounted() {
    await this.main()
  },
  methods: {
    async main() {
      this.$vs.loading();
      try {
        const {data} = await axios.get('/api/backoffice/navigation/menu/items');
        this.menus = data;

        const pendingRequestResponse = await axios.get('/api/security/temporary-access?me=true');
        this.pendingRequests = pendingRequestResponse.data;

        const lastRequestResponse = await axios.get('/api/security/temporary-access/last-requested?me=true');
        this.lastRequests = lastRequestResponse.data;
      } finally {
        this.$vs.loading.close();
      }
    },
    async saveRequestAccessHandler() {
      this.$vs.loading();
      try {
        await axios.post('/api/security/temporary-access', this.createRequestAccessForm)
        this.successNotif('¡Listo!', 'La solicitud de permiso se realizó correctamente');
        this.showCreateRequestAccess = false;
        await this.main()
      } catch (e) {
        this.$vs.loading.close();
        this.errorNotif('¡Ups!', 'El permiso no pudo ser solicitado');
      } finally {
        this.$vs.loading.close();
      }
    },
    async parentMenuHandler() {
      const { data } = await axios.get('/api/backoffice/navigation/menu/items?menu_item_id=' + this.parentMenu);
      this.subMenus = data;
    },
    async createRequestAccessHandler(requestAccess) {
      this.showCreateRequestAccess = true;
      if (requestAccess === null) {
        this.createRequestAccessForm = {
          id: null,
          menuItemId: null,
          requestPurpose: null,
          days: 7
        }
      } else {
        const { data } = await axios.get(
            `/api/backoffice/navigation/menu/item/${requestAccess.backoffice_navigation_menu_item_id}`
        );

        this.parentMenu = data.menu_item_id;

        await this.parentMenuHandler()

        this.createRequestAccessForm = {
          id: requestAccess.id,
          menuItemId: requestAccess.backoffice_navigation_menu_item_id,
          requestPurpose: requestAccess.request_purpose,
          days: requestAccess.days
        }
      }
      setTimeout(async () => await this.$validator.validate(), 500)
    }
  }
}
</script>

<style scoped>

</style>
